var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lite-diagram-viewer",
      class: { fullscreen: _vm.fullscreenMode },
    },
    [
      _c("div", { staticClass: "diagram-container" }, [
        _c(
          "div",
          {
            staticClass: "diagram-zoom-wrapper",
            style: { transform: "scale(" + _vm.zoomLevel + ")" },
          },
          [
            _c(
              "svg",
              {
                staticClass: "diagram-svg",
                attrs: { width: _vm.diagramWidth, height: _vm.diagramHeight },
              },
              [
                _c(
                  "defs",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-start",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#10b981",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#059669",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-webhook",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#3b82f6",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#2563eb",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-sleep",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#8b5cf6",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#7c3aed",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-contact",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#f59e0b",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#d97706",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-email",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#06b6d4",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#0891b2",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-ai",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#ec4899",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#db2777",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-filter",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#ef4444",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#dc2626",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-loop",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#14b8a6",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#0d9488",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-terminate",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#6b7280",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#4b5563",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-success",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#22c55e",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#16a34a",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-failure",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#f87171",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#ef4444",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "lite-gradient-default",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#9ca3af",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "0%" },
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: {
                            "stop-color": "#6b7280",
                            "stop-opacity": "1",
                          },
                          attrs: { offset: "100%" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "g",
                  { staticClass: "connections" },
                  _vm._l(_vm.connections, function (connection, index) {
                    return _c("path", {
                      key: "connection-" + index,
                      class: [
                        "connection-line",
                        {
                          executed: _vm.isConnectionExecuted(connection),
                          current: _vm.isConnectionCurrent(connection),
                        },
                      ],
                      attrs: {
                        d: connection.path,
                        stroke: "#94a3b8",
                        "stroke-width": "2",
                        fill: "none",
                        "marker-end": "url(#arrowhead)",
                      },
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "defs",
                  [
                    _c(
                      "marker",
                      {
                        attrs: {
                          id: "arrowhead",
                          markerWidth: "10",
                          markerHeight: "7",
                          refX: "9",
                          refY: "3.5",
                          orient: "auto",
                        },
                      },
                      [
                        _c("polygon", {
                          attrs: {
                            points: "0 0, 10 3.5, 0 7",
                            fill: "#94a3b8",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "marker",
                      {
                        attrs: {
                          id: "arrowhead-executed",
                          markerWidth: "8",
                          markerHeight: "6",
                          refX: "7",
                          refY: "3",
                          orient: "auto",
                        },
                      },
                      [
                        _c("polygon", {
                          attrs: { points: "0 0, 8 3, 0 6", fill: "#10b981" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "marker",
                      {
                        attrs: {
                          id: "arrowhead-current",
                          markerWidth: "10",
                          markerHeight: "7",
                          refX: "9",
                          refY: "3.5",
                          orient: "auto",
                        },
                      },
                      [
                        _c("polygon", {
                          attrs: {
                            points: "0 0, 10 3.5, 0 7",
                            fill: "#3b82f6",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "filter",
                      {
                        attrs: {
                          id: "glow-current",
                          x: "-50%",
                          y: "-50%",
                          width: "200%",
                          height: "200%",
                        },
                      },
                      [
                        _c("feGaussianBlur", {
                          attrs: { stdDeviation: "4", result: "coloredBlur" },
                        }),
                        _vm._v(" "),
                        _c(
                          "feMerge",
                          [
                            _c("feMergeNode", { attrs: { in: "coloredBlur" } }),
                            _vm._v(" "),
                            _c("feMergeNode", {
                              attrs: { in: "SourceGraphic" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "filter",
                      {
                        attrs: {
                          id: "glow-highlighted",
                          x: "-50%",
                          y: "-50%",
                          width: "200%",
                          height: "200%",
                        },
                      },
                      [
                        _c("feGaussianBlur", {
                          attrs: { stdDeviation: "3", result: "coloredBlur" },
                        }),
                        _vm._v(" "),
                        _c(
                          "feMerge",
                          [
                            _c("feMergeNode", { attrs: { in: "coloredBlur" } }),
                            _vm._v(" "),
                            _c("feMergeNode", {
                              attrs: { in: "SourceGraphic" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "current-position-gradient",
                          x1: "0%",
                          y1: "0%",
                          x2: "100%",
                          y2: "100%",
                        },
                      },
                      [
                        _c(
                          "stop",
                          {
                            staticStyle: {
                              "stop-color": "#60a5fa",
                              "stop-opacity": "0.8",
                            },
                            attrs: { offset: "0%" },
                          },
                          [
                            _c("animate", {
                              attrs: {
                                attributeName: "stop-color",
                                values:
                                  "#60a5fa;#3b82f6;#1d4ed8;#3b82f6;#60a5fa",
                                dur: "2s",
                                repeatCount: "indefinite",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "stop",
                          {
                            staticStyle: {
                              "stop-color": "#1d4ed8",
                              "stop-opacity": "0.9",
                            },
                            attrs: { offset: "100%" },
                          },
                          [
                            _c("animate", {
                              attrs: {
                                attributeName: "stop-color",
                                values:
                                  "#1d4ed8;#1e40af;#1e3a8a;#1e40af;#1d4ed8",
                                dur: "2s",
                                repeatCount: "indefinite",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "g",
                  { staticClass: "blocks" },
                  _vm._l(_vm.positionedBlocks, function (block) {
                    return _c(
                      "g",
                      {
                        key: block.id,
                        class: [
                          "block-group",
                          {
                            highlighted: _vm.isBlockHighlighted(block.id),
                            executed: _vm.isBlockExecuted(block.id),
                            current: _vm.isBlockCurrent(block.id),
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.handleBlockClick(block)
                          },
                        },
                      },
                      [
                        _vm.isBlockCurrent(block.id) ||
                        _vm.isBlockHighlighted(block.id)
                          ? _c("rect", {
                              staticClass: "block-glow",
                              attrs: {
                                x: block.x - 8,
                                y: block.y - 8,
                                width: block.width + 16,
                                height: block.height + 16,
                                fill: _vm.isBlockCurrent(block.id)
                                  ? "#dc2626"
                                  : "#3b82f6",
                                opacity: "0.2",
                                rx: "12",
                                ry: "12",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("rect", {
                          staticClass: "block-rect",
                          attrs: {
                            x: block.x,
                            y: block.y,
                            width: block.width,
                            height: block.height,
                            fill: _vm.getBlockFill(block),
                            stroke: _vm.getBlockStroke(block.id),
                            "stroke-width": _vm.getBlockStrokeWidth(block.id),
                            filter: _vm.getBlockFilter(block.id),
                            opacity: _vm.getBlockOpacity(block.id),
                            rx: "6",
                            ry: "6",
                          },
                        }),
                        _vm._v(" "),
                        _vm.hasBlockValue(block.id)
                          ? _c("circle", {
                              staticClass: "value-indicator",
                              attrs: {
                                cx: block.x + 15,
                                cy: block.y + 15,
                                r: "4",
                                fill: "#10b981",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasBlockValue(block.id)
                          ? _c(
                              "text",
                              {
                                staticClass: "value-indicator-text",
                                attrs: {
                                  x: block.x + 15,
                                  y: block.y + 18,
                                  "text-anchor": "middle",
                                  fill: "white",
                                  "font-size": "8",
                                  "font-weight": "600",
                                },
                              },
                              [_vm._v("●")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isBlockCurrent(block.id)
                          ? _c("g", { staticClass: "current-indicator" }, [
                              _c(
                                "text",
                                {
                                  staticClass: "current-stop-icon",
                                  attrs: {
                                    x: block.x - 15,
                                    y: block.y + block.height / 2 + 4,
                                    "text-anchor": "middle",
                                    fill: "#dc2626",
                                    "font-size": "16",
                                  },
                                },
                                [_vm._v("⏹️")]
                              ),
                              _vm._v(" "),
                              _c(
                                "text",
                                {
                                  staticClass: "current-text",
                                  attrs: {
                                    x: block.x + block.width / 2,
                                    y: block.y - 12,
                                    "text-anchor": "middle",
                                    fill: "#dc2626",
                                    "font-size": "11",
                                    "font-weight": "600",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "auto.liteDiagramViewerOtomasyonBuradaSonlandRLd"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isBlockHighlighted(block.id)
                          ? _c("g", { staticClass: "highlight-indicator" }, [
                              _c(
                                "text",
                                {
                                  staticClass: "highlight-location-icon",
                                  attrs: {
                                    x: block.x - 15,
                                    y: block.y + block.height / 2 + 4,
                                    "text-anchor": "middle",
                                    fill: "#3b82f6",
                                    "font-size": "16",
                                  },
                                },
                                [_vm._v("📍")]
                              ),
                              _vm._v(" "),
                              _c(
                                "text",
                                {
                                  staticClass: "highlight-text",
                                  attrs: {
                                    x: block.x + block.width / 2,
                                    y: block.y - 12,
                                    "text-anchor": "middle",
                                    fill: "#3b82f6",
                                    "font-size": "11",
                                    "font-weight": "600",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "auto.liteDiagramViewerUanBuKonumda"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "block-icon",
                            attrs: {
                              x: block.x + 12,
                              y: block.y + block.height / 2 + 6,
                              fill: _vm.getBlockTextColor(block.type),
                              opacity: _vm.getBlockOpacity(block.id),
                            },
                          },
                          [_vm._v(_vm._s(_vm.getBlockIcon(block.type)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            staticClass: "block-name",
                            attrs: {
                              x: block.x + 32,
                              y: block.y + block.height / 2 + 4,
                              fill: _vm.getBlockTextColor(block.type),
                              opacity: _vm.getBlockOpacity(block.id),
                            },
                          },
                          [_vm._v(_vm._s(_vm.getBlockDisplayName(block)))]
                        ),
                        _vm._v(" "),
                        _vm.getExecutionOrder(block.id) > 0
                          ? _c("circle", {
                              staticClass: "execution-badge",
                              attrs: {
                                cx: block.x + block.width - 10,
                                cy: block.y + 10,
                                r: "8",
                                fill: "#3b82f6",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getExecutionOrder(block.id) > 0
                          ? _c(
                              "text",
                              {
                                staticClass: "execution-order",
                                attrs: {
                                  x: block.x + block.width - 10,
                                  y: block.y + 14,
                                  fill: "white",
                                  "text-anchor": "middle",
                                },
                              },
                              [_vm._v(_vm._s(_vm.getExecutionOrder(block.id)))]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "diagram-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _vm.showPayloadButton
              ? _c(
                  "a-button",
                  {
                    attrs: { size: "small", type: "default" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("showPayload")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("code"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.liteDiagramViewerPlanPayload")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "toolbar-right" },
          [
            _c(
              "a-button-group",
              [
                _c(
                  "a-button",
                  {
                    attrs: {
                      size: "small",
                      type: "default",
                      title: _vm.$t("auto.liteDiagramViewerUzaklaTR"),
                    },
                    on: { click: _vm.zoomOut },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("zoom_out"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      size: "small",
                      type: "default",
                      title: _vm.$t("auto.liteDiagramViewerZoomSFRla"),
                    },
                    on: { click: _vm.resetZoom },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("center_focus_strong"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      size: "small",
                      type: "default",
                      title: _vm.$t("auto.liteDiagramViewerYakNlaTR"),
                    },
                    on: { click: _vm.zoomIn },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("zoom_in"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: {
                  size: "small",
                  type: "default",
                  title: _vm.fullscreenMode ? "Tam Ekrandan Çık" : "Tam Ekran",
                },
                on: { click: _vm.toggleFullscreen },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.fullscreenMode ? "fullscreen_exit" : "fullscreen"
                      ) +
                      "\n                "
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "diagram-legend" }, [
        _c("div", { staticClass: "legend-item" }, [
          _c("div", { staticClass: "legend-color current" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("auto.liteDiagramViewerSonlandRLdKonum"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "legend-item" }, [
          _c("div", { staticClass: "legend-color executed" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("auto.liteDiagramViewerAlTRLanBlock"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "legend-item" }, [
          _c("div", { staticClass: "legend-color highlighted" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("auto.liteDiagramViewerTraceEdilenBlock"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }